import { API } from "aws-amplify"
import api, { apiName } from "./constants"

export async function getCarousel() {
    try {
        return await API.get(apiName, `${api.carousel}/`, {})
    } catch (error) {
        console.error(error)
    }
}
